import { is_device } from './DeviceID';
import type { DeviceID } from './DeviceID';
import type { SceneConditionTransform } from './ScenesConditionsTypes';
export type TriggerTypeUI = {
	cond_type_id?: string | number;
	cond_type_name: string;
	valid_for_min?: number | string | undefined;
};

export type DeviceConditionUI = {
	device: DeviceID;
	cond_name: string; //turn/ input_state/roller_direction/temperature
	operator: string; //equal, less_than, more_than
	value: string; //desired value - onn/off/detected/75
	add_info_ind?: number | undefined;
	add_on_id?: number;
	sensor_name?: string; // ona dditional update of this type
	// meter_ind?: number;
	input_index?: number;
	cond_type?: TriggerTypeUI; //Condition type for the trigger
	type?: string; //Type of the device condition (e.g. 'virtual_component')
	remote_control_channel?: string; //Remote control channel condition used with SBRC-005B
	transform?: SceneConditionTransform; //Optional reference transformation, e.g. camera object recognition
};

export type DeviceTriggerUI = DeviceConditionUI & {
	cond_type: TriggerTypeUI;
};

export function is_device_cond_ui(obj: any): obj is DeviceConditionUI {
	return (
		typeof obj === 'object' &&
		is_device(obj.device) &&
		typeof (obj as any).operator !== 'undefined' &&
		typeof (obj as any).value !== 'undefined'
	);
}

export function is_device_trigger_ui(obj: any): obj is DeviceTriggerUI {
	return typeof obj === 'object' && typeof obj.cond_type !== 'undefined' && is_device(obj.device);
}
